import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=5db6e637&"
import script from "./ConfigurationList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db6e637')) {
      api.createRecord('5db6e637', component.options)
    } else {
      api.reload('5db6e637', component.options)
    }
    module.hot.accept("./ConfigurationList.vue?vue&type=template&id=5db6e637&", function () {
      api.rerender('5db6e637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/ConfigurationList.vue"
export default component.exports